import React from 'react';
import "./Accueil.scss"
import { images } from '../../constants';



const accueil = () => {
  return (
    <>
    <section className='hero' id='accueil'>
        <div className='container f_flex top'>
            <div className='left top'>
                <h1>
                     <a href='#accueil'><span>Aldôlo</span></a>,
                  un monde meilleur vous attend!
                </h1>
            <div className='hero_btn d_flex'>

                <div className='col_1'>
                    <h4>Nos technologies</h4>
                    <button className='btn_shadow'>
                        <img src={images.react} alt='React'/>
                    </button>
                    <button className='btn_shadow'>
                        <img src={images.node} alt='node'/>
                    </button>
                    <button className='btn_shadow'>
                        <img src={images.ai} alt='ai'/>
                    </button>
                    <button className='btn_shadow'>
                        <img src={images.api} alt='api'/>
                    </button>

                    <button className='btn_shadow'>
                        <img src={images.firebase} alt='firebase'/>
                    </button>
                    <button className='btn_shadow'>
                        <img src={images.python} alt='Python'/>
                    </button>
                    <button className='btn_shadow'>
                        <img src={images.flutter} alt='flutter'/>
                    </button>
                    <button className='btn_shadow'>
                        <img src={images.cpp} alt='cpp'/>
                    </button>

                    <button className='btn_shadow'>
                        <img src={images.java} alt='Java'/>
                    </button>
                    <button className='btn_shadow'>
                        <img src={images.blender} alt='blender'/>
                    </button>
                    <button className='btn_shadow'>
                        <img src={images.adobe} alt='adobe'/>
                    </button>
                    <button className='btn_shadow'>
                        <img src={images.google} alt='google'/>
                    </button>

                </div>
            </div>
            </div>
            <div className='right'>
                <div className="rotation">
                    <div>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}

export default accueil;